/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // my Custom Functions
  $.fn.addFooter = function(){
    $(this).addClass('m-block').removeClass('m-none').removeClass('d-none');
  };
  $.fn.noSpace = function(){
    $(this).children().last().children().addClass('no-margin').find('.none').hide();
  };
  $.fn.currentViewport = function(){
    $(this).each(function(i){
      var offset = $(this).offset();
      var height = $(this).height()-40;
      var w = $(window);
      var position = offset.top - w.scrollTop();
      if (position <=40 && position >= -height ) {
        $(this).addClass('current');
      } else {
        $(this).removeClass('current');
      }
    });
  };
  $.fn.LeftRight = function(){
    $(this).each(function(i){
      var itemPosition = $(this).offset().left;
      var itemWidth = $(this).width();
      if (itemPosition > 0) {
        $(this).addClass('right');
      } else {
        $(this).addClass('left');
      }
    });
  };
  $.fn.addColor = function(){
    $(this).on('ab-color-found', function(ev, payload){
      $('.ab-dark').closest('.wrap').find('h1').addClass('light');
      $('.ab-dark').closest('.wrap').find('.burger').addClass('light');
      $(window).scroll(function(){
       if ($('.current-changer.single-image').hasClass('ab-dark')) {
        $('.current-changer.single-image').closest('.wrap').find('h1').addClass('dark');
        $('.current-changer.single-image').closest('.wrap').find('h1').removeClass('light');
        $('.current-changer.single-image').closest('.wrap').find('.burger').addClass('dark');
        $('.current-changer.single-image').closest('.wrap').find('.burger').removeClass('light');
      } else if ($('.current.single-image').hasClass('ab-dark')) {
        $('.current.single-image').closest('.wrap').find('h1').addClass('light');
        $('.current.single-image').closest('.wrap').find('h1').removeClass('dark');
        $('.current.single-image').closest('.wrap').find('.burger').addClass('light');
        $('.current.single-image').closest('.wrap').find('.burger').removeClass('dark');
      }
      });
    });
  }
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      finalize: function() {
        $('a').each(function() {
           var a = new RegExp('/' + window.location.host + '/');
           if (!a.test(this.href)) {
              $(this).attr("target","_blank").addClass('exterLink');
           }
        });
        // We listen to the resize event
        window.addEventListener('resize', () => {
          // We execute the same script as before
          let vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
        $('.menu-toggle').on('click', function(){
          $(this).toggleClass('is-active');
          $(this).closest('.wrap').toggleClass('all-black'); // Make Background Black
          $(this).closest('.row').next().toggleClass('d-flex'); // Display Menu
          $(this).closest('header').toggleClass('h-100 all-black'); // Important for Manu Flex Alignment
          $(this).closest('html').toggleClass('all-black overflow'); // Make Background Black
          $('footer').toggle();
        });
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $.adaptiveBackground.run({});
          $('.bgimage').on('ab-color-found', function(ev, payload){
            $('.ab-dark').closest('.slick-slide').addClass('dark');
            $('.ab-light').closest('.slick-slide').addClass('light');
            $('.slick-current.dark').closest('.wrap').addClass('light');
            $('.slick-current.light').closest('.wrap').addClass('dark');
          });
        }
      },
      finalize: function() {
        $('.slick').slick({
          'arrows' : true,
          'autoplay' : true,
          'autoplaySpeed' : 3000
        });
          if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $('.slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $('.ab-dark').closest('.slick-slide').addClass('dark');
            $('.ab-light').closest('.slick-slide').addClass('light');
            if ($('.slick-current.dark').next().hasClass('light')) {
              $(this).closest('.wrap').removeClass('light');
              $(this).closest('.wrap').addClass('dark');
            }
            else if ($('.slick-current.light').next().hasClass('dark')) {
              $(this).closest('.wrap').removeClass('dark');
              $(this).closest('.wrap').addClass('light');
            }
          });
        }
      }
    },
    'page_template_default': {
      init: function() {
        $('footer').addFooter();
      },
      finalize: function() {
      }
    },
    'page_template_template_about': {
      init: function() {
        $('footer').addFooter();
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $.adaptiveBackground.run({});
          $('.single-image').addColor();
        }
      },
      finalize: function() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $(window).scroll(function(){
          var offset = $('.single-image').offset();
          var height = $('.single-image').height()-40;
          var w = $(window);
          var position = offset.top - w.scrollTop();
          if (position <=40 && position >= -height ) {
            $('.single-image').addClass('current');
            $('.single-image').removeClass('current-changer');
          } else {
            $('.single-image').removeClass('current');
            $('.single-image').addClass('current-changer');
          }
        });
      }
      }
    },
    'single': {
      init: function() {
        $('iframe').wrap('<div class="iframe-container"></div>');
        $('.iframe-container').wrap('<div class="col-sm-7 col-12 mx-auto d-block m-4"></div>');
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
        $('.gallery').children().last().children().addClass('no-margin').find('.none').hide(); // no margin on the last element of the gallery
        $.adaptiveBackground.run({});
        $('.single-image').addColor();
      }
      },
      finalize: function() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $(window).scroll(function(){
          var offset = $('.single-image').offset();
          var height = $('.single-image').height()-40;
          var w = $(window);
          var position = offset.top - w.scrollTop();
          if (position <=40 && position >= -height ) {
            $('.single-image').addClass('current');
            $('.single-image').removeClass('current-changer');
          } else {
            $('.single-image').removeClass('current');
            $('.single-image').addClass('current-changer');
            }
          });
        }
      }
    },
    'news_template_default': {
      init: function() {
        $('.gallery').noSpace();
        // JavaScript to be fired on the home page
      },
      finalize: function() {
      }
    },
    'post_type_archive_news': {
      init: function() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
        $.adaptiveBackground.run({});
        $('.colorswitcher').on('ab-color-found', function(ev, payload){
          $('.ab-dark').closest('.wrap').find('h1').addClass('light');
          $('.ab-light').closest('.wrap').find('h1').removeClass('light');
          $('.ab-dark').closest('.wrap').find('.burger').addClass('light');
          $('.ab-light').closest('.wrap').find('.burger').removeClass('light');
          $(window).scroll(function(){
           if ($('.current.colorswitcher').hasClass('ab-dark')) {
            $('.current.colorswitcher').closest('.wrap').find('h1').addClass('light');
            $('.current.colorswitcher').closest('.wrap').find('h1').removeClass('dark');
            $('.current.colorswitcher').closest('.wrap').find('.burger').addClass('light');
            $('.current.colorswitcher').closest('.wrap').find('.burger').removeClass('dark');
          } else if ($('.current.colorswitcher').hasClass('ab-light')) {
            $('.current.colorswitcher').closest('.wrap').find('h1').addClass('dark');
            $('.current.colorswitcher').closest('.wrap').find('h1').removeClass('light');
            $('.current.colorswitcher').closest('.wrap').find('.burger').addClass('dark');
            $('.current.colorswitcher').closest('.wrap').find('.burger').removeClass('light');
          }
          });
        });
      }
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $(window).scroll(function() {
            $('.colorswitcher').currentViewport();
          });
          $(window).resize(function(){
            $('.colorswitcher').LeftRight();
            $(window).scroll(function() {
              $('.colorswitcher').currentViewport();
            });
          });

        }
      }
    },
    // Projects, note the change from about-us to about_us.
    'post_type_archive_projects': {
      init: function() {
        $('.gallery').noSpace();
        $('.grid').isotope({
          itemSelector: '.grid-item',
          percentPosition: true,
          masonry: {
            columnWidth: '.grid-sizer'
          }
        });
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          $(window).resize(function(){
            if (window.matchMedia('(max-width: 575.98px)').matches) {
              $('footer').addFooter();
              $('.footer').css('margin-top','3.5rem');
            }
          });
          if (window.matchMedia('(max-width: 575.98px)').matches) {
            $('footer').addFooter();
            $('.footer').css('margin-top','3.5rem');
          }
        } else {
        $.adaptiveBackground.run({});
        $('.project-image').on('ab-color-found', function(ev, payload){
          $('.1.ab-dark').closest('.wrap').find('h1').addClass('light');
          $('.1.ab-light').closest('.wrap').find('h1').addClass('dark');
          $('.2.ab-light').closest('.wrap').find('.burger').addClass('dark');
          $('.2.ab-dark').closest('.wrap').find('.burger').addClass('light');
          $(window).scroll(function(){
            if ($('.left.current').hasClass('ab-dark')) {
              $('.left.current').closest('.wrap').find('h1').addClass('light');
              $('.left.current').closest('.wrap').find('h1').removeClass('dark');
            } else {
              $('.left.current').closest('.wrap').find('h1').addClass('dark');
              $('.left.current').closest('.wrap').find('h1').removeClass('light');
            }
            if ($('.right.current').hasClass('ab-dark')) {
              $('.right.current').closest('.wrap').find('.burger').addClass('light');
              $('.right.current').closest('.wrap').find('.burger').removeClass('dark');
            } else {
              $('.right.current').closest('.wrap').find('.burger').addClass('dark');
              $('.right.current').closest('.wrap').find('.burger').removeClass('light');
            }
          });
        });
      }
        // JavaScript to be fired on the about us page
      },
      finalize: function(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        } else {
          $('.project-image').LeftRight();
        $(window).scroll(function() {
          $('.project-image').currentViewport();
        });
        $(window).resize(function(){
          $('.project-image').LeftRight();
          $(window).scroll(function() {
            $('.project-image').currentViewport();
          });
        });
      }
      },
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
